import React from 'react';

export default function Question(props){
    return (
        <p>{props.question}</p>
    );
}